import { useMutation } from "@tanstack/react-query";
import { createAxiosWithAuth } from "./middleware";

export const useCreateRequest = () => {
  const axios = createAxiosWithAuth();

  return useMutation({
    mutationKey: ["fuel-request-create"],
    mutationFn: async (query) => {
      return await axios.post("/agent/createfr", query);
    },
  });
};